export const UsernamePattern = '^[a-zA-Z0-9]{4,50}$';
export const UsernamePatternErrorMessage =
  'Username must be at least 4 characters long and contain only alphanumeric characters (letters and numbers).'
